import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput } from 'src/api/process-module';

interface HtmlFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const HtmlField = ({ field, index, handleFieldChange, isSubmitting, isUsingExistingField }: HtmlFieldProps) => {
  return (
    <>
      <TextField
        fullWidth
        label="HTML Content"
        value={field.dataSource || (field as any).properties?.dataSource || ''}
        onChange={(e) => handleFieldChange(index, { dataSource: e.target.value })}
        disabled={isSubmitting || isUsingExistingField}
        multiline
        minRows={4}
        helperText="Enter HTML content"
      />
    </>
  );
};
